import React from "react";
import Icon from "components/AppIcon";

const EnergyXPPanel = ({ energy, maxEnergy, xp, xpToNext, level, regenTime }) => {
  const safeEnergy = typeof energy === 'number' ? energy : 0;
  const safeMaxEnergy = typeof maxEnergy === 'number' && maxEnergy > 0 ? maxEnergy : 100;
  const safeXp = typeof xp === 'number' ? xp : 0;
  const safeXpToNext = typeof xpToNext === 'number' && xpToNext > 0 ? xpToNext : 1000;
  const safeLevel = typeof level === 'number' ? level : 1;

  const energyPct = Math.min(100, Math.max(0, (safeEnergy / safeMaxEnergy) * 100));
  const xpPct = Math.min(100, Math.max(0, (safeXp / safeXpToNext) * 100));

  const energyColor =
    energyPct > 50
      ? "var(--color-accent)"
      : energyPct > 20
      ? "var(--color-warning)"
      : "var(--color-error)";

  return (
    <div
      className="rounded-xl border border-border p-4 md:p-5"
      style={{ background: "var(--color-card)" }}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-sm font-semibold text-foreground">Status</h3>
        <span
          className="font-caption text-xs px-2 py-0.5 rounded"
          style={{
            background: "rgba(0,217,255,0.1)",
            color: "var(--color-primary)",
            border: "1px solid rgba(0,217,255,0.2)",
          }}
        >
          LVL {safeLevel}
        </span>
      </div>
      {/* Energy */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-1.5">
          <div className="flex items-center gap-1.5">
            <Icon name="Zap" size={13} color="var(--color-accent)" />
            <span className="font-caption text-xs text-muted-foreground">Energy</span>
          </div>
          <span className="font-caption text-xs" style={{ color: energyColor }}>
            {safeEnergy}/{safeMaxEnergy}
          </span>
        </div>
        <div className="h-2 rounded-full overflow-hidden" style={{ background: "var(--color-muted)" }}>
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${energyPct}%`,
              background: energyColor,
              boxShadow: energyPct > 50 ? "var(--glow-amber)" : "none",
            }}
          />
        </div>
        <p className="font-caption text-xs text-muted-foreground mt-1">
          {regenTime ? `+1 energy in ${regenTime}` : 'Energy regenerating...'}
        </p>
      </div>
      {/* XP */}
      <div>
        <div className="flex items-center justify-between mb-1.5">
          <div className="flex items-center gap-1.5">
            <Icon name="Star" size={13} color="var(--color-primary)" />
            <span className="font-caption text-xs text-muted-foreground">XP Progress</span>
          </div>
          <span className="font-caption text-xs text-primary">
            {safeXp?.toLocaleString()}/{safeXpToNext?.toLocaleString()}
          </span>
        </div>
        <div className="h-2 rounded-full overflow-hidden" style={{ background: "var(--color-muted)" }}>
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${xpPct}%`,
              background: "var(--color-primary)",
              boxShadow: "var(--glow-sm)",
            }}
          />
        </div>
        <p className="font-caption text-xs text-muted-foreground mt-1">
          {(safeXpToNext - safeXp)?.toLocaleString()} XP to Level {safeLevel + 1}
        </p>
      </div>
    </div>
  );
};

export default EnergyXPPanel;